import styled, { keyframes } from 'styled-components/macro'

import { Logo as LogoBase } from 'components/icons/logo'
import { theme } from 'styles/theme'
import { motion } from 'framer-motion'
import { Overlay } from 'styles/misc'

export const View = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--background);
  z-index: 999;
`

const loading = keyframes`
  from { transform: scaleX(.5) translateX(-150%); }
  to   { transform: scaleX(.5) translateX(150%); }
`

export const Spinner = styled(motion.div)`
  position: relative;
  height: 0.5rem;
  width: 20rem;
  max-width: calc(100% - 4rem);
  margin-top: 3rem;
  overflow: hidden;

  &::before {
    ${Overlay}
    content: "";
    opacity: 0.1;
    background: currentColor;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    animation: 1s ${loading} ease-in-out infinite;
    background-color: ${theme.colors.theme};
  }
`

export const Logo = styled(LogoBase)`
  font-size: 12rem;
`
